import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledSegmentWrapper = styled.div`
margin: 2em 0em;

.header {
	margin-left: 0 !important;
	width: auto !important;
	margin-right: 0 !important;
	border-top-right-radius: 1em !important;
	border-top-left-radius: 1em !important;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.title {
		font-size: 15px !important;
	}
}

.segmetBody {
	justify-content: space-between !important;
}

.message {
	margin-top: 20px;
	text-align: center;
	border-radius: 10px;
}

.segment {
	margin-left: 0 !important;
	min-height: 150px !important;
	width: auto !important;
	margin-right: 0 !important;
	border-bottom-right-radius: 1em !important;
	border-bottom-left-radius: 1em !important;
	display: flex;
	flex-wrap: wrap;
}

.messageClass {
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
}
`
export const CardAttributeWrapper = styled.div`
max-width: 45%;
min-width: 45%;
margin: 10px;
border-radius: 1em;
.cardSettings {
  padding: 20px;
  padding-top: 30px;
  margin-bottom: 20px;
  background-color: rgb(241,245,249) !important;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 0 solid transparent;
  border-radius: 10px;
  .deleteWrapper {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }
}
`

export const FiltersWrapper = styled.div`
display: flex;
align-items: baseline;
flex-wrap: wrap;
gap: 10px;s
`
export const StyledFiltersOptions = styled(Dropdown)`
font-size: 1.2rem !important;
 .divider.text {
  margin: 0.45238095em 0 0.45238095em -1em !important; 
 }
`